import { z } from 'zod';

/**
 * Wire schemas for allergen API responses (snake_case).
 * These match the Gateway response format.
 *
 * IMPORTANT: Backend stores:
 * - Timestamps as ISO string DATETIME, not Unix numbers
 * - Curated / FDA flags as 0/1 integers, not booleans
 * - Optional fields can be null, not just undefined
 */
export const allergenWireSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable().optional(),
  is_curated: z.number().int(),
  is_fda_big_nine: z.number().int(),
  created_at: z.string(), // D1 DATETIME (ISO format)
  updated_at: z.string(), // D1 DATETIME (ISO format)
});

export type AllergenWire = z.infer<typeof allergenWireSchema>;

/**
 * Paginated allergen response wrapper schema.
 * Mirrors createPaginatedResponseSchema from the Gateway.
 */
export const paginatedAllergenResponseSchema = z.object({
  items: z.array(allergenWireSchema),
  total: z.number().int().min(0),
  page: z.number().int().min(1),
  per_page: z.number().int().min(1).max(100),
  total_pages: z.number().int().min(0),
});

export type PaginatedAllergenResponseWire = z.infer<typeof paginatedAllergenResponseSchema>;
